import type { QuoteStateType } from "~/shared/types/quote-details-types.ts";

export const getQuoteDetailsFingerprint = (
	quoteState: QuoteStateType,
): string => {
	const detailsForRequote = {
		customerId: quoteState.customer?.id ?? null,
		shipmentDate: quoteState.shipmentDate,
		pickupCountry: quoteState.pickupCountry,
		deliveryCountry: quoteState.deliveryCountry,
		pickupPostalCode: quoteState.pickupPostalCode,
		deliveryPostalCode: quoteState.deliveryPostalCode,
		items: quoteState.items,
		pickupServices: quoteState.pickupServices,
		deliveryServices: quoteState.deliveryServices,
		addtDetails: quoteState.addtDetails,
		customerReference: quoteState.customerReference,
		poNumbers: quoteState.poNumbers,
		soNumber: quoteState.soNumber,
		specialInstructions: quoteState.specialInstructions,
		emergencyContactName: quoteState.emergencyContactName ?? "",
		emergencyContactPhone: quoteState.emergencyContactPhone ?? "",
		totalLinearFeet: quoteState.totalLinearFeet,
		customTotalLinearFeet: quoteState.customTotalLinearFeet,
		measuringType: quoteState.measuringType,
		insuranceValue: quoteState.insuranceValue,
		insuranceApplyType: quoteState.insuranceApplyType ?? null,
		insuranceApplyTypeId: quoteState.insuranceApplyTypeId,
		insuranceProductType: quoteState.insuranceProductType ?? null,
		insuranceProductTypeId: quoteState.insuranceProductTypeId,
		templateId: quoteState.templateId,
	};

	return JSON.stringify(detailsForRequote);
};
